import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  gql,
} from "@apollo/client";
import { getAccessToken } from "./Auth/auth";
 
 
//const endpoint_URL = "http://localhost:9000/graphql"; //"https://api.calendrier-triathlon.fr/graphql";
const endpoint_URL = "https://api.calendrier-triathlon.fr/graphql";
 
const authLink = new ApolloLink((operation, forward) => {
  //const token = localStorage.getItem("accessToken");
  const token = getAccessToken();
 
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  }));
  return forward(operation);
});
 
const httpLink = new HttpLink({
  uri: endpoint_URL,
  fetchOptions: { mode: "cors" },
});
 
const client = new ApolloClient({
  ssrMode: false,
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({ addTypename: false }),
});
 
 
 
const userQuery = gql`
  query UserQuery($id: ID) {
    user(id: $id) {
      id
      email
      firstname
      role
    }
  }
`;
 
const userQuery2 = gql`
  query UserQuery {
    user {
      email
      firstname
      role
    }
  }
`;
 
// Fragment corrigée : ne référence que des champs réellement présents
// dans le type Race du schéma GraphQL (les anciens champs swim_place,
// bike_place, run_place, bike_elevation, run_elevation n'existent pas
// et faisaient échouer toute requête utilisant cette fragment).
const raceFragmentDetail = gql`
  fragment RaceDetail on Race {
    id
    event_id
    date
    name_race
    type_triathlon
    details
    price_triathlon
    bibs
    relay
    Elevation_bike
    Elevation_run
    Swimenv
    crosstri
    rolling_start
  }
`;
const organisationFragmentDetail = gql`
  fragment OrganisationDetail on Organisation {
    id
    department
    name_org
    contact
    address
    zipcode
    city
    region
    phonenumber
    email
    website
    facebook
  }
`;
 
const epreuveFragmentDetail = gql`
  fragment EpreuveDetail on Epreuve {
    id
    id_organisateur
    date
    name_event
    city
    department
    region
    mapCoord
    description
  }
`;
 
// mutation
// const createEvent = gql`
//   mutation createEvent($input: createEventInput) {
//     epreuve: createEvent(input: $input) {
//       ...EpreuveDetail
//     }
//   }
//   ${epreuveFragmentDetail}
// `;
 
// display one event with organization and races -> by id
const epreuveQuery = gql`
  query EpreuveQuery($id: ID!) {
    epreuve(id: $id) {
      id
      id_organisateur
      date
      name_event
      description
      city
      department
      region
      map_coord
      organisation {
        id
        department
        name_org
        contact
        address
        zipcode
        city
        region
        phonenumber
        email
        website
        facebook
      }
      races {
        id
        event_id
        date
        name_race
        type_triathlon
        details
        price_triathlon
        bibs
        relay
        Elevation_bike
        Elevation_run
        Swimenv
        crosstri
      }
    }
  }
`;
 
const epreuveQuery2 = gql`
  query EpreuveQuery {
    epreuve {
      id_organisateur
      date
      name_event
      description
      city
      department
      region
      map_coord
      races {
        event_id
        date
        name_race
        type_triathlon
        details
        price_triathlon
        bibs
        relay
        Elevation_bike
        Elevation_run
        Swimenv
        crosstri
      }
    }
  }
`;
 
// display one organization -> by id
const organisationQuery = gql`
  query OrganisationQuery($id: ID!) {
    organisation(id: $id) {
      id
      department
      name_org
      contact
      address
      zipcode
      city
      region
      phonenumber
      email
      website
      facebook
    }
  }
`;
// display one race -> by id
const raceQuery = gql`
  query RaceQuery($id: ID!) {
    race(id: $id) {
      ...RaceDetail
    }
  }
  ${raceFragmentDetail}
`;
// display all races
const racesQuery = gql`
  query RacesQuery {
    races {
      ...RaceDetail
    }
  }
  ${raceFragmentDetail}
`;
 
// display all organizations
const organisationsQuery = gql`
  query OrganisationsQuery($name_org: String) {
    organisations(name_org: $name_org) {
      id
      department
      name_org
      contact
      address
      zipcode
      city
      region
      phonenumber
      email
      website
      facebook
      epreuves {
        id
        name_event
      }
    }
  }
`;
//  ${organisationFragmentDetail} -> fragment
// displays all events with filters
const epreuvesQuery = gql`
  query EpreuvesQuery(
    $region: String
    $name: String
    $month: Int
    $year: Int
    $type: [String]
    $relay: String
    $Elevation_bike: Int
    $Elevation_run: Int
    $bibs: Int
    $Swimenv: [String]
    $crosstri: [String]
  ) {
    epreuves(
      region: $region
      name_event: $name
      monthSelected: $month
      yearSelected: $year
      type_triathlon: $type
      relay: $relay
      Elevation_bike: $Elevation_bike
      Elevation_run: $Elevation_run
      bibs: $bibs
      Swimenv: $Swimenv
      crosstri: $crosstri
    ) {
      id
      id_organisateur
      date
      name_event
      description
      city
      department
      region
      map_coord
      organisation {
        id
        department
        name_org
        contact
        address
        zipcode
        city
        region
        phonenumber
        email
        website
        facebook
      }
      races {
        id
        event_id
        date
        name_race
        type_triathlon
        details
        price_triathlon
        bibs
        relay
        Elevation_bike
        Elevation_run
        Swimenv
        crosstri
      }
    }
  }
`;
 
//////////////////////////////////////// MUTATIONS //////////////////////////////////////////////////
 
// create one event with races and organisation
const epreuvesMutation = gql`
  mutation CreateEpreuve($input: CreateEpreuveInput!) {
    epreuve: createEpreuve(input: $input) {
      date
      name_event
      description
      city
      department
      region
      map_coord
      id_organisateur
      races {
        date
        name_race
        type_triathlon
        details
        price_triathlon
        bibs
        relay
        Elevation_bike
        Elevation_run
        Swimenv
        crosstri
      }
    }
  }
`;
 
const organisationMutation = gql`
  mutation CreateOrganisation($input: CreateOrganisationInput!) {
    organisation: createOrganisation(input: $input) {
      id
      name_org
      department
      region
      contact
      address
      zipcode
      city
      phonenumber
      email
      website
      facebook
    }
  }
`;
 
const userMutation = gql`
  mutation CreateUser($input: CreateUserInput!) {
    user: createUser(input: $input) {
      email
      firstname
    }
  }
`;
 
const updateMutation = gql`
  mutation UpdateOrganisation($input: UpdateOrganisationInput!) {
    organisation: updateOrganisation(input: $input) {
      id
      name_org
      department
      region
      contact
      address
      zipcode
      city
      phonenumber
      email
      website
      facebook
      epreuves {
        name_event
      }
    }
  }
`;
 
// list of exports functions to use its in the app
 
export async function loadRaces() {
  const {
    data: { races },
  } = await client.query({ query: racesQuery });
  return races;
}
 
export async function loadEpreuves({
  region,
  name,
  month,
  year,
  type,
  relay,
  Elevation_bike,
  Elevation_run,
  bibs,
  Swimenv,
  crosstri,
}) {
  const {
    data: { epreuves },
  } = await client.query({
    query: epreuvesQuery,
    variables: {
      region,
      name,
      month,
      year,
      type,
      relay,
      Elevation_bike,
      Elevation_run,
      bibs,
      Swimenv,
      crosstri,
    },
  });
  return epreuves;
}
 
//////////////////////////////////////// Functions QUERY ////////////////////////////////
export async function loadUser(id) {
  const {
    data: { user },
  } = await client.query({ query: userQuery, variables: { id } });
  return user;
}
 
export async function loadOrganisations(name_org) {
  const {
    data: { organisations },
  } = await client.query({
    query: organisationsQuery,
    variables: { name_org },
    fetchPolicy: "network-only",
  });
  return organisations;
}
 
export async function loadRace(id) {
  const {
    data: { race },
  } = await client.query({ query: raceQuery, variables: { id } });
  return race;
}
 
//get data for one event triathlon by id
export async function loadEpreuve(id) {
  const {
    data: { epreuve },
  } = await client.query({ query: epreuveQuery, variables: { id } });
  return epreuve;
}
 
export async function loadOrganisation(id) {
  const {
    data: { organisation },
  } = await client.query({ query: organisationQuery, variables: { id } });
  return organisation;
}
 
//////////////////////////////////////// Functions MUTATION or UPDATE ////////////////////////////////
export async function createEvent(input) {
  try {
    const { data } = await client.mutate({
      mutation: epreuvesMutation,
      variables: { input },
      update: (cache, { data }) => cache.writeQuery({ query: epreuveQuery2, data }),
    });
    return data.createEpreuve;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
 
 
 
export async function createOrganisation(input) {
  try {
    const { data } = await client.mutate({
      mutation: organisationMutation,
      variables: { input },
      update: (cache, { data }) => {
        if (!data || !data.organisation) return;
 
        // On ne passe plus de variables id undefined au cache
        cache.writeQuery({
          query: organisationQuery,
          // Si tu veux filtrer par id, assure-toi que data.organisation.id existe
          data: { organisation: data.organisation },
        });
      },
    });
 
    console.log("data organisationMutation from request React", data);
    return data.organisation;
  } catch (error) {
    console.error("GraphQL Error in createOrganisation:", error);
    throw error; // Propager l'erreur pour gérer côté UI
  }
}
 
 
export async function createUser(input) {
  try {
    const { data } = await client.mutate({
      mutation: userMutation,
      variables: { input },
      update: (cache, { data: mutationData }) =>
        cache.writeQuery({ query: userQuery2, data: mutationData }),
    });
    return data.createUser;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
 
 
export async function updateOrganisation(input) {
  if (!input?.id) {
    throw new Error("updateOrganisation: input.id manquant");
  }
 
  const { data } = await client.mutate({
    mutation: updateMutation,
    variables: { input },
  });
 
  return data.organisation;
}
